import Service from '@ember/service';

import { use } from 'ember-resources';
import { RemoteData } from 'reactiveweb/remote-data';

import config from 'umg-ember-backend/config/environment';

const FALLBACK_FONTS = {
  'sans-serif': 'sans-serif',
  'serif': 'serif',
  'monospace': 'monospace',
  'display': 'cursive',
  'handwriting': 'cursive',
};

export default class GoogleFontsService extends Service {
  // Defaults
  @use fonts = RemoteData(
    `https://www.googleapis.com/webfonts/v1/webfonts?key=${config.AUTH.googleFontsApiKey}&sort=alpha`,
  );

  // Getter and setter
  get items() {
    return (
      this.fonts.value?.items.map((item) => {
        return {
          family: item.family,
          familyWithFallback: `"${item.family}", ${FALLBACK_FONTS[item.category]}`,
          variants: item.variants,
          type: 'google-font',
        };
      }) ?? []
    );
  }

  get families() {
    return this.items.map((item) => {
      return {
        value: item.family,
        label: item.family,
      };
    });
  }
}
